<template>
<!-- 题目管理 弹窗：批量导入题目 -->
    <el-dialog :title="importTextConfig.title"
               v-if="dialogVisible"
               :visible.sync="dialogVisible"
               width="500px"
               @close="close"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
            <el-upload
                drag action="void"
                :limit="1" multiple
                name="file"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadFile"
                :on-progress="progressA"
                :on-remove="handleRemove"
                :auto-upload="true"
                style="padding-bottom:20px">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" v-html="importTextConfig.uploadText"></div>
            <div class="el-upload__tip" slot="tip" style="text-align:center">
                {{ importTextConfig.uploadTip }}<br />
                <el-button type="text" style="margin-left:20px">
                    <a :href="config_env.BASE_URL+'/api/question_bank/question/import_template'">{{ importTextConfig.download }}</a>
                </el-button>
                <p v-if="info" style="margin-top:8px">
                    <i class="el-icon-warning-outline"></i> {{info}}
                </p>
            </div>
        </el-upload>
    </el-dialog>
</template>

<script>
import request from '../../../utils/request'
export default {
    props: ['show'],
    data() {
        return {
            dialogVisible: false,
            http: null,
            fileList:[],
            info:''
        };
    },
    computed: {
        importTextConfig() {
            return this.$store.state.global.textConfig.backend.question.table.button.import
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        }
    },
    methods: {
        beforeAvatarUpload (file) {
            this.info = ''
            var testmsg = file.name.substring(file.name.lastIndexOf('.')+1)
            const extension = testmsg === 'docx'
            if (file.size>850000) {
                this.info = this.importTextConfig.tooMany
            }
            const isLt2M = file.size / 1024 / 1024 < 200
            if(!extension) {
                this.$message({
                    message: '上传文件只能是DOCX格式!',
                    type: 'warning'
                });
            }
            if(!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 200MB!',
                    type: 'warning'
                });
            }
            return extension && isLt2M
        },
        uploadFile (file) {
            let f = file.file
            let formData = new FormData();
            formData.append("file", f);
            this.http = request({
                url: `/api/question_bank/${this.$parent.id}/question/batch/inspection`,
                method: 'post',
                data: formData,
                //上传进度
                onUploadProgress: (progressEvent) => {
                    let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
                    file.onProgress({percent: num})     //进度条
                }
            }).then(res => {
                file.onSuccess(); //上传成功(打钩的小图标)
                this.info = ''
                if (res.status == 200) {
                    if (res.data) {
                        if (res.data.questions.length) {
                            this.close()
                            this.$message({
                                message: this.importTextConfig.success,
                                type: 'success'
                            });
                            localStorage.setItem("verificationData", JSON.stringify(res.data));
                            this.$router.push({path:'/verification',query:{id:this.$parent.id}})
                        }else {
                            this.$message({
                                message: this.importTextConfig.error,
                                type: 'error'
                            });
                        }
                    }else {
                        this.$message({
                            message: this.importTextConfig.error,
                            type: 'error'
                        });
                    }
                }
            })
        },
        handleRemove(file) {
            this.http.abort(); //取消上传
            this.$message({message: '成功移除' + file.name, type: 'success'});
            this.errorList = []
        },
        /**     文件正在上传时的钩子    **/
        progressA(event, file) {},
        close() {
            this.dialogVisible = false
            this.$emit('close', false)
        }
    }
}
</script>

<style>
    .el-upload, .el-upload-dragger {
        width: 100%;
    }
</style>
